import apiClient from "./axios"

// Get all vehicle movements with optional filtering
export const getVehicleMovements = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-movements", { params })
  return data
}

// Get a specific vehicle movement by ID
export const getVehicleMovement = async id => {
  const { data } = await apiClient.get(`/vehicle-movements/${id}`)
  return data
}

// Create a new vehicle movement
export const createVehicleMovement = async movementData => {
  const { data } = await apiClient.post("/vehicle-movements", movementData)
  return data
}

// Update an existing vehicle movement
export const editVehicleMovement = async ({ id, ...movementData }) => {
  const { data } = await apiClient.patch(
    `/vehicle-movements/${id}`,
    movementData
  )
  return data
}

// Delete a vehicle movement (soft delete)
export const deleteVehicleMovement = async id => {
  const { data } = await apiClient.delete(`/vehicle-movements/${id}`)
  return data
}

// Get all vehicle movements without pagination
export const getAllVehicleMovements = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-movements", {
    params: { ...params, all: true },
  })
  return data
}

// Search vehicle movements by vehicle stock title, chassis, or remarks
export const searchVehicleMovements = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/vehicle-movements", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed vehicle movements
export const getTrashedVehicleMovements = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-movements/trashed", { params })
  return data
}

// Restore a trashed vehicle movement
export const restoreVehicleMovement = async id => {
  const { data } = await apiClient.post(`/vehicle-movements/${id}/restore`)
  return data
}
